import http from './http'

export async function ping(): Promise<boolean> {
	try {
		const res = await http.get('/api/ping')
		return Boolean(res?.data)
	} catch {
		return false
	}
}


